import { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { NavDropdown } from 'react-bootstrap'
import Brand from '@/components/brand'
import Styles from './style.module.scss'
import ClassName from 'clsx'
import useLang from '@/utils/hooks/use-lang'
import MenuPro from '@/components/menu-pro'
import { Flex } from 'antd'

const langs = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'Español',
    value: 'es',
  },
  {
    label: '简体中文',
    value: 'cn',
  },
]

function Logo({ soul = false }) {
  const navigate = useNavigate()
  const backToHome = () => navigate('/')

  return <Brand white={soul} onClick={backToHome} />
}

function Extra({ soul = false }) {
  const navigate = useNavigate()
  const [lang] = useLang()
  const handleLangChange = useCallback(l => {
    localStorage.setItem('lang', l)
    setTimeout(() => {
      window.location.reload()
    })
  }, [])
  return (
    <Flex align='center' gap={16} className={ClassName(soul && Styles.soul)}>
      <div className={Styles.contact} onClick={() => navigate('/contact')}>
        Contact Us
      </div>
      <Flex align='center' className={Styles.language}>
        <NavDropdown title={<span className={Styles.text}>{lang === 'cn' ? '简体中文' : lang}</span>}>
          {(langs || [])?.map(({ label, value }) => (
            <NavDropdown.Item key={value} onClick={() => handleLangChange(value)}>
              {label}
            </NavDropdown.Item>
          ))}
        </NavDropdown>
      </Flex>
    </Flex>
  )
}

export default function Index({ soul = false }) {
  const [hover, setHover] = useState(false)
  const [scroll, setScroll] = useState(0)
  const handleScroll = () => {
    const position = window.scrollY
    setScroll(position)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const isFixed = (soul && scroll > 0) || hover || !soul

  const isSoul = soul && scroll === 0 && !hover

  return (
    <MenuPro
      soul={isSoul}
      logo={<Logo soul={isSoul} />}
      extra={<Extra soul={isSoul} />}
      className={ClassName(Styles.nav, soul && Styles.soul, isFixed && Styles.sticky)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    />
  )
}
